import React from 'react';
import get from 'lodash.get';
import { connect } from 'react-redux';

import ApplyAndAddEmpCard from '../../ApplyAndAddEmpCard';
import TcLinks from '../../TcLinks';
import {
  Element,
  Color,
  FontType,
  ContentBannerWithImageAndCard,
  Breakpoint,
  Typography
} from '@americanexpress/aqx-components';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { getSelectedColorInfo } from 'src/universal/redux/cardColors';
import { decideCardArtUrl } from 'src/universal/utils/cardColorChoices';

import applyButtonStyles from '../__styles__/RIBApply.scss?modules';
import styles from '../__styles__/summitBanner.scss?modules';

const ReinforcementBannerEventKey = 'ReinforcementBanner';

const SummitReinforcementBanner = ({ bannerData, hasUpgradeCta, colorInfo }) => {
  const { cardArt, cardAlt, title, assets, dtm: scrollDtm } = bannerData;
  const cardArtUrl = decideCardArtUrl(cardArt, colorInfo);
  const tncProps = {
    styles: styles,
    parent: ReinforcementBannerEventKey
  };
  if (hasUpgradeCta) {
    tncProps.customKeys = ['offerTermsUpgrade', 'ratesFeesUpgrade'];
  }
  return (
    <Breakpoint>
      {({ sm }) => {
        const imageUrl = sm ? get(assets, 'mobile.url') : get(assets, 'desktop.url');
        return (
          <LazyScrollMetricTracker
            scrollDtm={scrollDtm}
            startTrackingAfterPznArrival={true}
          >
            <Element className={styles.wrapper}>
              <ContentBannerWithImageAndCard
                qeId="bannerImageCard"
                data={{
                  body: (
                    <Element className={styles.body}>
                      <Element className={styles.titleWrapper}>
                        <Typography
                          Component="h2"
                          $family={FontType.BentonBold}
                          $size={sm ? 24 : 30}
                          $lineHeight={'130%'}
                          theme={{ color: Color.DeepBlue }}
                        >
                          {title}
                        </Typography>
                      </Element>
                      <Element className={styles.buttonWrapper}>
                        <ApplyAndAddEmpCard
                          styles={applyButtonStyles}
                          parent={`_${ReinforcementBannerEventKey}`}
                          linkType="reinforcement"
                          hasUpgradeCta={hasUpgradeCta}
                        />
                      </Element>
                      <Element className={styles.tncWrapper}>
                        <TcLinks {...tncProps} />
                      </Element>
                    </Element>
                  ),
                  imageUrl: imageUrl,
                  cardImage: cardArtUrl,
                  cardImageAlt: cardAlt
                }}
              />
            </Element>
          </LazyScrollMetricTracker>
        );
      }}
    </Breakpoint>
  );
};

const mapStateToProps = (state, ownProps) => ({
  colorInfo: getSelectedColorInfo(ownProps.bannerData?.shortName)(state)
});

export default connect(mapStateToProps)(SummitReinforcementBanner);
